export function normalizeString(value) {
  return value ? value.toString().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '') : '';
}

export function matchesSearch(item, fields, query) {
  if (!query) {
    return true;
  }
  const normalizedQuery = normalizeString(query);
  return fields.some(field => normalizeString(item[field]).includes(normalizedQuery));
}

export function applyPagination(items, pagination = {}) {
  const page = Math.max(1, Number(pagination.page) || 1);
  const perPage = Math.max(1, Number(pagination.perPage) || 10);
  const start = (page - 1) * perPage;
  const paginatedItems = items.slice(start, start + perPage);
  const totalItems = items.length;
  return {
    items: paginatedItems,
    pageInfo: {
      totalItems,
      totalPages: Math.max(1, Math.ceil(totalItems / perPage)),
      page,
      perPage,
    },
  };
}

export function sortPurchasesByDate(items) {
  return [...items].sort((a, b) => new Date(b.fecha).getTime() - new Date(a.fecha).getTime());
}

export function deepClone(value) {
  return JSON.parse(JSON.stringify(value));
}

